// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"otp-elapsed-time-count_actionButton__T17H0","buttonText":"otp-elapsed-time-count_buttonText__AvwV8"};